export default __webpack_public_path__ + "static/media/tick-white.be87753c.svg";